import React from 'react';

import { useForm } from 'react-hook-form';
import { Button } from '@infoods/lifebase-ui';

import classes from './SetPasswordForm.module.scss';
import { TextInfo } from '../../components/TextInfo/TextInfo';
import { passwordService } from '../../../../services/passwordService';
import { PasswordInput } from '../../../../../shared/components/form-components';
import { AccessParams } from '../../../../../shared/interfaces/AccessParams';

export type SetPasswordFormFields = {
  password: 'string';
  confirmPassword: 'string';
};

export type SetPasswordFormProps = {
  goToNextStep: () => void;
  accessParams: AccessParams;
};

const SetPasswordForm = ({ goToNextStep, accessParams }: SetPasswordFormProps) => {
  const { control, handleSubmit } = useForm<SetPasswordFormFields>({
    mode: 'onChange',
  });

  const onSubmit = async (data: SetPasswordFormFields) => {
    await passwordService.setPassword(accessParams, data.password);

    goToNextStep();
  };

  const validateConfirmPassword = (
    confirmPassword: string,
    formValue: SetPasswordFormFields,
  ) => {
    return confirmPassword === formValue.password || "Passwords don't match";
  };

  return (
    <>
      <TextInfo
        title="Set the password"
        text="To use the SWYMO app, please set up a password below"
      />
      <form
        onSubmit={handleSubmit(onSubmit)}
        className={classes.setPasswordForm}
        noValidate
      >
        <PasswordInput
          label="New Password"
          control={control}
          name="password"
          helperText="Length must be at least 12 characters"
        />
        <PasswordInput
          label="Confirm Password"
          control={control}
          name="confirmPassword"
          rules={{
            validate: validateConfirmPassword,
          }}
          omitValidation
        />
        <Button type="submit" variant="contained">
          Set the Password
        </Button>
      </form>
    </>
  );
};

export { SetPasswordForm };
